import { PaginationRequestType } from '../../../../types/paginationRequestType';
import { SurveyContext } from './Survey';

export enum QuestionType {
  Text = 'Text',
  MultipleChoice = 'MultipleChoice',
  SingleChoice = 'SingleChoice',
}

interface Scale {
  id: string;
}

interface SurveyQuestionBase {
  text: string;
  type: QuestionType;
  metadata?: Record<string, any> | null;
  order: number | null;
}

interface ScaleQuestion extends SurveyQuestionBase {
  id?: string;
  scale: Scale;
}

type Question = ScaleQuestion;

interface SurveySection {
  id?: string;
  title?: string;
  name: string;
  description?: string;
  questions: Question[];
}

export interface SurveyDraftContent {
  period: { id: number; name: string };
  sections: SurveySection[];
}

export interface CreateSurveyDraftRequest {
  id?: string;
  title: string;
  startDate: string;
  endDate: string;
  context: SurveyContext;
  content: SurveyDraftContent;
}

export interface SurveyDraft {
  id: string;
  title: string;
  description: string;
  startDate: string;
  endDate: string;
  context: SurveyContext;
  content: SurveyDraftContent;
  createdAt: string;
  updatedAt: string;
}

export type SurveyDraftListResponseType = PaginationRequestType<SurveyDraft>;
export type SurveyDraftResponseType = SurveyDraft;

export interface UpdateSurveyRequest {
  title?: string;
  description?: string;
  status?: string;
  startDate?: Date;
  endDate?: Date;
  content?: SurveyDraftContent;
}
